export const parseTimestamp = (input: string): number | undefined => {
  const trimmed = input.trim();
  if (!trimmed) return undefined;

  const parts = trimmed.split(':');

  if (parts.length === 1) {
    const seconds = Number(parts[0]);
    return Number.isFinite(seconds) && seconds >= 0 ? seconds : undefined;
  }

  if (parts.length === 2) {
    const [m, s] = parts.map(Number);
    if (!Number.isFinite(m) || !Number.isFinite(s)) return undefined;
    if (m < 0 || s < 0 || s >= 60) return undefined;
    return m * 60 + s;
  }

  if (parts.length === 3) {
    const [h, m, s] = parts.map(Number);
    if (!Number.isFinite(h) || !Number.isFinite(m) || !Number.isFinite(s))
      return undefined;
    if (h < 0 || m < 0 || m >= 60 || s < 0 || s >= 60) return undefined;
    return h * 3600 + m * 60 + s;
  }

  return undefined;
};
